import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom';
import Fullpage, {FullPageSections, FullpageSection} from '@ap.cx/react-fullpage';
import {Typography, Checkbox, Button, Paper, Grid} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import {createReaderQuestionAnswerAndQuizResult} from 'api/question';
import {createKeyboardEvent} from 'utils/common';

const levelColorMap = {
  1: '#FFFF00',
  2: '#5cb85c',
  3: '#f46e01',
};

const arrowDownEvent = createKeyboardEvent('ArrowDown', 40);

const arrowUpEvent = createKeyboardEvent('ArrowUp', 38);

const usePageStyles = withStyles({
  paper: {
    height: '80vh',
  },
  homeTitle: {
    width: '60%',
    height: '80%',
    margin: '0 auto',
    paddingTop: '20%',
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  homeFooter: {
    textAlign: 'center',
    height: '20%',
  },
  sectionTitle: {
    width: '60%',
    height: '80%',
    margin: '0 auto',
    paddingTop: '15%',
    textAlign: 'left',
    overflow: 'auto',
    textOverflow: 'ellipsis',
  },
  sectionFooter: {
    textAlign: 'center',
    paddingTop: '5%',
    height: '20%',
  },
  optionLabel: {
    fontSize: 20,
  },
  nextButton: {
    backgroundColor: '#22a1c4',
    color: 'white',
  },
});

const QuizFullPage = usePageStyles(({quiz, user, closeQuizFullPage, questions, classes}) => {
  const homePage = [
    {
      id: quiz.id,
      title: quiz.title,
    },
  ];
  const sectionPage = questions.map((question) => ({
    id: question.id,
    title: question.title,
    options: question.singleSelect.options,
    correctAnswer: question.answer,
    answer: '',
  }));
  const initialFullPages = homePage.concat(sectionPage);

  const [fullPages, setfullPages] = useState(initialFullPages);
  const [refreshKey, setRefreshKey] = useState(1);

  const next = () => {
    document.body.dispatchEvent(arrowDownEvent);
  };

  const back = () => {
    document.body.dispatchEvent(arrowUpEvent);
  };

  const handleChange = (value, id) => {
    fullPages.forEach((page) => {
      if (page.id === id.toString()) {
        page.answer = value;
      }
    });
    setfullPages(fullPages);
    setRefreshKey(refreshKey + 1);
    document.body.dispatchEvent(arrowDownEvent);
  };

  const submit = () => {
    const questionAndAnswer = [];
    let correctAnswerCnt = 0;
    let totalQuestionCnt = 0;
    fullPages.forEach((page, index) => {
      if (index !== 0) {
        questionAndAnswer.push({question_id: page.id, answer: page.answer});
        if (page.correctAnswer === page.answer) {
          correctAnswerCnt++;
        }
        totalQuestionCnt++;
      }
    });
    createReaderQuestionAnswerAndQuizResult({
      readerId: user.id,
      quizId: quiz.id,
      correctAnswerCnt: correctAnswerCnt,
      totalQuestionCnt: totalQuestionCnt,
      questionAndAnswer,
    }).then(() => closeQuizFullPage());
  };

  const sectionsColor = levelColorMap[quiz.level];

  return (
    <Fullpage>
      <FullPageSections>
        {fullPages.map((page, index) =>
          index === 0 ? (
            <FullpageSection key={'section' + index} style={{backgroundColor: sectionsColor}}>
              <div style={{padding: '100px 100px 0px 100px'}}>
                <Paper className={classes.paper}>
                  <div className={classes.homeTitle}>
                    <Typography variant="h3">{page.title}</Typography>
                  </div>
                  <div className={classes.homeFooter}>
                    <Grid container justify="space-around">
                      <Grid item>
                        <Button variant="contained" color="default" onClick={closeQuizFullPage}>
                          exit
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button className={classes.nextButton} variant="contained" onClick={next}>
                          next
                        </Button>
                      </Grid>
                    </Grid>
                  </div>
                </Paper>
              </div>
            </FullpageSection>
          ) : (
            <FullpageSection key={'section' + index} style={{backgroundColor: sectionsColor}}>
              <div style={{padding: 100}}>
                <Paper className={classes.paper}>
                  <div className={classes.sectionTitle}>
                    <Typography variant="h5">{page.title}</Typography>
                    <FormControl key={refreshKey} component="fieldset">
                      <RadioGroup
                        name="single-select"
                        value={page.answer}
                        onChange={({target}) => handleChange(target.value, page.id)}
                      >
                        {page.options.map((option, idx) => (
                          <FormControlLabel
                            key={'option' + idx}
                            value={option}
                            control={<Radio color="primary" />}
                            label={option}
                            classes={{label: classes.optionLabel}}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                  </div>
                  <div className={classes.sectionFooter}>
                    <Grid container justify="space-around">
                      <Grid item>
                        <Button variant="contained" color="default" onClick={back}>
                          back
                        </Button>
                      </Grid>
                      <Grid item>
                        {index === fullPages.length - 1 ? (
                          <Button className={classes.nextButton} variant="contained" onClick={submit}>
                            submit
                          </Button>
                        ) : (
                          <Button className={classes.nextButton} variant="contained" onClick={next}>
                            next
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                  </div>
                </Paper>
              </div>
            </FullpageSection>
          ),
        )}
      </FullPageSections>
    </Fullpage>
  );
});

export default QuizFullPage;
